import qs from "qs";

export default {
    namespaced: true,
    state: {
        popup_open: false,
        popup_title: "",
        popup_message: "",
        product_id: null,
        save_user_msg: {}
    },
    mutations: {
        popup_visibility(state, status) {
            state.popup_open = status;
        },
        set_title(state, title) {
            state.popup_title = title
        },
        set_message(state, message) {
            state.popup_message = message
        },
        set_product_id(state, id) {
            state.product_id = id
        },
        set_msg_after_save(state, msg) {
            state.save_user_msg = msg
        }
    },
    actions: {
        async add_to_waitlist({commit, state}, user_email) {
            let parameters = {
                action: 'setDataForWaitList',
                user_email: user_email,
                product_id: state.product_id,
                security: window.global.ajax_nonce,
            }
            await this.axios.post(window.global.ajax, qs.stringify(parameters), {withCredentials: true}).then((res) => {
                commit('set_msg_after_save', {'success': res.data.success, 'msg': res.data.data.message})
            }).catch((e) => {
                console.log('error')
            })
        }
    },
    getters: {
        is_open: (state) => state.popup_open,
        get_title: (state) => state.popup_title,
        get_message: (state) => state.popup_message,
        get_product_id: (state) => state.product_id,
        get_msg_after_save: (state) => state.save_user_msg
    }
};